import {environments, appUrls, apiBaseUrls} from '@/constants/app.js'
import {teamsAppIdsV3} from '@/constants/teams.js'
import {computed, ref} from 'vue'

/**
 * Environment composable
 */
export function useEnv() {

  //Origin and hostname
  const href = computed(() => window.location.href)
  const origin = computed(() => window.location.origin)
  const hostname = computed(() => window.location.hostname)
  const port = computed(() => window.location.port)

  //Determine app environment
  const env = ref(import.meta.env.VITE_APP_ENV)

  //App base url
  const appBaseUrl = computed(() => {
    switch (env.value) {
      case environments.LOCAL:
        return appUrls.LOCAL
      case environments.DEV:
        return appUrls.DEV
      case environments.QA:
        return appUrls.QA
      case environments.STAGING:
        return appUrls.STAGING
      case environments.PRODUCTION:
      default:
        return appUrls.PRODUCTION
    }
  })

  //API base URL
  const apiBaseUrl = computed(() => {
    switch (env.value) {
      case environments.LOCAL:
        return apiBaseUrls.LOCAL
      case environments.DEV:
        return apiBaseUrls.DEV
      case environments.QA:
        return apiBaseUrls.QA
      case environments.STAGING:
        return apiBaseUrls.STAGING
      case environments.PRODUCTION:
      default:
        return apiBaseUrls.PRODUCTION
    }
  })

  //Teams app ID V3
  const teamsAppIdV3 = computed(() => {
    switch (env.value) {
      case environments.LOCAL:
      case environments.DEV:
        return teamsAppIdsV3.DEV
      case environments.QA:
        return teamsAppIdsV3.QA
      case environments.STAGING:
        return teamsAppIdsV3.STAGING
      case environments.PRODUCTION:
      default:
        return teamsAppIdsV3.PRODUCTION
    }
  })

  //Git hash
  const gitHash = ref(import.meta.env.VITE_APP_GIT_HASH)

  //Helper refs
  const isLocal = computed(() => env.value === environments.LOCAL)
  const isDev = computed(() => env.value === environments.DEV)
  const isQa = computed(() => env.value === environments.QA)
  const isStaging = computed(() => env.value === environments.STAGING)
  const isProduction = computed(() => env.value === environments.PRODUCTION)

  //Special check for Vitest and test env
  const isVitest = computed(() => typeof process !== 'undefined' ? !!process.env.VITEST : false)
  const isTest = computed(() => isVitest.value)

  //Expose interface
  return {
    env,
    href,
    origin,
    hostname,
    port,
    appBaseUrl,
    apiBaseUrl,
    isLocal,
    isDev,
    isQa,
    isStaging,
    isProduction,
    isVitest,
    isTest,
    gitHash,
    teamsAppIdV3,
  }
}
